import { DeliverySettingsContainer } from '@/modules/DeliverySettings';

export const DeliverySettings = (): JSX.Element => <DeliverySettingsContainer />;

export default DeliverySettings;
